module.exports = __webpack_public_path__ + "img/sankaku_51_red.d5f08af8.png";